import React, { useState } from 'react';
import { Button } from './Button';
import { Clock, Check, Sparkles } from 'lucide-react';
import { ExitIntentUpsell } from './ExitIntentUpsell';
import { trackAddToCart, trackInitiateCheckout } from '../lib/metaPixel';
// Shopify checkout URLs
const CART_URL_MAIN_ONLY = 'https://www.ebookpromax.com/cart/52487752810789:1';
const CART_URL_BUNDLE = 'https://www.ebookpromax.com/cart/52487752909093:1';
// Popup upsell (30% off bump) — points to bundle cart by default.
// Replace with a dedicated discounted variant URL if you create one.
const CART_URL_UPSELL = 'https://www.ebookpromax.com/cart/52487752909093:1';
export function Offer() {
  const [bumpSelected, setBumpSelected] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const basePrice = 17999;
  const bumpPrice = 9990;
  const totalPrice = bumpSelected ? basePrice + bumpPrice : basePrice;
  const formatPrice = (n: number) => n.toLocaleString('es-AR');
  const handleBumpToggle = () => {
    const next = !bumpSelected;
    setBumpSelected(next);
    // Fire AddToCart only when the bump is being ADDED (not when removed)
    if (next) {
      trackAddToCart({
        content_name: 'Moldes de Silicona Caseros (Order Bump)',
        value: bumpPrice
      });
    }
  };
  const handleCheckoutClick = () => {
    if (bumpSelected) {
      trackInitiateCheckout({
        content_name: 'Arte con Cemento + Moldes de Silicona (Bundle)',
        value: basePrice + bumpPrice,
        num_items: 2
      });
      window.location.href = CART_URL_BUNDLE;
    } else {
      // Popup will fire its own InitiateCheckout on accept/decline
      setShowUpsell(true);
    }
  };
  return <section id="oferta" className="py-24 bg-sage-900 relative overflow-hidden" data-id="element-220">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1618220179428-22790b46a0eb?q=80&w=2000&auto=format&fit=crop')] bg-cover bg-center opacity-5 mix-blend-overlay" data-id="element-221"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-600/10 rounded-full blur-3xl pointer-events-none" data-id="element-222"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-223">
        <div className="max-w-3xl mx-auto bg-sand-50 rounded-[2.5rem] p-8 md:p-14 shadow-premium border border-gold-300/30" data-id="element-224">
          <div className="text-center mb-10" data-id="element-225">
            <div className="inline-flex items-center gap-2 bg-terracotta-50 text-terracotta-600 px-4 py-1.5 rounded-full font-bold text-xs uppercase tracking-widest mb-6 border border-terracotta-100" data-id="element-226">
              <Clock className="w-3.5 h-3.5" data-id="element-227" />
              Oferta por tiempo limitado
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-concrete-900 mb-4 text-embossed" data-id="element-228">
              Comienza tu viaje creativo hoy
            </h2>
            <p className="text-concrete-600 text-base font-light" data-id="element-229">
              Obtén el programa completo + todos los bonos de regalo
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 mb-8 text-center border border-sand-200 shadow-sm relative overflow-hidden" data-id="element-230">
            <div className="absolute top-0 inset-x-0 h-1 bg-metallic-gold" data-id="element-231"></div>

            <p className="text-concrete-400 font-medium text-sm mb-1 uppercase tracking-widest" data-id="element-232">
              Precio Normal
            </p>
            <p className="text-xl text-concrete-300 line-through font-medium mb-6" data-id="element-233">
              $39.990 ARS
            </p>

            <p className="text-terracotta-500 font-bold uppercase tracking-widest text-xs mb-2" data-id="element-234">
              Precio Especial Hoy
            </p>
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-235">
              <span className="text-5xl md:text-6xl font-heading font-semibold text-concrete-900 transition-all duration-300" data-id="element-236">
                ${formatPrice(totalPrice)}
              </span>
              <span className="text-xl font-medium text-concrete-500 mt-4" data-id="element-237">
                ARS
              </span>
            </div>
            <p className="text-xs text-concrete-500 font-light tracking-wide" data-id="element-238">
              {bumpSelected ? 'Programa + Moldes de Silicona Caseros' : 'Pago único. Acceso de por vida.'}
            </p>
          </div>

          {/* ORDER BUMP */}
          <div className="relative mb-10" data-id="element-239">
            {/* Floating badge — sits ABOVE the button (outside its overflow-hidden) */}
            <div className={`absolute -top-3 left-6 bg-gold-400 text-white text-[10px] md:text-xs font-bold uppercase tracking-widest px-4 py-1 rounded-full flex items-center gap-1.5 shadow-md z-20 ${!bumpSelected ? 'animate-bounce' : ''}`} data-id="element-240">
              <Sparkles className="w-3 h-3" data-id="element-241" />
              Sumá y ahorrá
            </div>

            <button type="button" onClick={handleBumpToggle} aria-pressed={bumpSelected} className={`
                w-full text-left rounded-3xl p-6 border
                transition-all duration-500 group relative overflow-hidden
                ${bumpSelected ? 'border-sage-500 bg-sage-50 shadow-md' : 'border-gold-300 bg-white hover:border-gold-400 hover:shadow-md animate-attention-pulse shine-sweep'}
              `} data-id="element-242">
              <div className="flex items-start gap-5" data-id="element-243">
                <div className={`
                  flex-shrink-0 w-6 h-6 rounded border flex items-center justify-center
                  transition-all duration-300 mt-1
                  ${bumpSelected ? 'bg-sage-600 border-sage-600' : 'bg-sand-50 border-sand-300 group-hover:border-gold-400'}
                `} data-id="element-244">
                  {bumpSelected && <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-245" />}
                </div>

                <img src="https://cdn.shopify.com/s/files/1/0999/7487/3381/files/order_bump.png?v=1779992128" alt="Moldes de silicona caseros" className="hidden sm:block w-24 h-24 rounded-xl object-contain bg-sand-50 flex-shrink-0 border border-sand-100 p-2" data-id="element-246" />

                <div className="flex-1 min-w-0" data-id="element-247">
                  <div className="flex items-baseline justify-between gap-3 flex-wrap mb-2" data-id="element-248">
                    <h3 className="font-semibold text-concrete-900 text-base md:text-lg leading-snug font-heading" data-id="element-249">
                      ¡SÍ! Quiero sumar los Moldes de Silicona Caseros
                    </h3>
                    <span className="font-bold text-terracotta-500 text-lg whitespace-nowrap" data-id="element-250">
                      + ${formatPrice(bumpPrice)} ARS
                    </span>
                  </div>
                  <p className="text-sm text-concrete-600 font-light leading-relaxed" data-id="element-251">
                    Aprendé a fabricar tus propios moldes desde casa con
                    materiales económicos. Diseñá piezas únicas e imposibles de
                    copiar y multiplicá tus ganancias.
                  </p>
                </div>
              </div>
            </button>
          </div>

          <div className="flex flex-col items-center gap-8" data-id="element-252">
            <Button size="xl" fullWidth onClick={handleCheckoutClick} data-id="element-253">
              COMPRAR AHORA POR ${formatPrice(totalPrice)} ARS
            </Button>

            <div className="w-full" data-id="element-254">
              <img src="https://cdn.magicpatterns.com/uploads/k416oho9DajNCLkUGDUWG8/MERCADOLIDER.jpg" alt="Pago seguro garantizado con Visa, Mastercard, Maestro y Mercado Pago. MercadoLíder Platinum con más de 145.000 ventas." className="w-full max-w-md mx-auto object-contain mix-blend-multiply opacity-80" data-id="element-255" />
            </div>
          </div>
        </div>
      </div>

      <ExitIntentUpsell isOpen={showUpsell} onClose={() => setShowUpsell(false)} onAccept={() => {
      setShowUpsell(false);
      trackInitiateCheckout({
        content_name: 'Arte con Cemento + Moldes (Bundle 30% OFF — Exit Intent)',
        value: 24992,
        num_items: 2
      });
      window.location.href = CART_URL_UPSELL;
    }} onDecline={() => {
      setShowUpsell(false);
      trackInitiateCheckout({
        content_name: 'Arte con Cemento (Solo producto principal)',
        value: basePrice,
        num_items: 1
      });
      window.location.href = CART_URL_MAIN_ONLY;
    }} data-id="element-256" />
    </section>;
}